var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.form.content.length
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, n) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        n = _temp2.n
      var _temp, _temp2
      _vm.form.depositScore = n + 1
    }
    _vm.e1 = function ($event, n) {
      var _temp3 = arguments[arguments.length - 1].currentTarget.dataset,
        _temp4 = _temp3.eventParams || _temp3["event-params"],
        n = _temp4.n
      var _temp3, _temp4
      _vm.form.driverScore = n + 1
    }
    _vm.e2 = function ($event, n) {
      var _temp5 = arguments[arguments.length - 1].currentTarget.dataset,
        _temp6 = _temp5.eventParams || _temp5["event-params"],
        n = _temp6.n
      var _temp5, _temp6
      _vm.form.takeScore = n + 1
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }